import { useEffect } from 'react';

/**
 * Domain redirects are handled by Lovable hosting via the Primary domain
 * setting (physiowrld.rs must be Primary). Redirecting other connected
 * domains here as well creates a loop whenever the Primary is set
 * differently, so this only normalizes www.physiowrld.rs, which is not a
 * connected hosting domain.
 */
const DomainRedirect = () => {
  useEffect(() => {
    if (window.location.hostname === 'www.physiowrld.rs') {
      window.location.replace(
        `https://physiowrld.rs${window.location.pathname}${window.location.search}${window.location.hash}`,
      );
    }
  }, []);

  return null;
};

export default DomainRedirect;
